import React, { useState } from 'react';
import Menu from '../../components/Menu/Menu';
import './Setting.scss'

const Setting = () => {
  const [activeTab, setActiveTab] = useState('tab1'); // 使用useState来管理激活的选项卡

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div>
      <div className='setting-header container mt-5 d-flex justify-content-between'>
        <Menu/>
        <div className='d-flex align-items-center setting-title'>SETTING</div>
      </div>
      <div className="container mt-4">
        <div className="row">
          <div className="setting-sidebar col-md-3">
            <ul className="nav flex-column setting-sidebar">
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`}
                  href="#"
                  onClick={() => handleTabChange('tab1')}
                >
                  About ChatGPT
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === 'tab2' ? 'active' : ''}`}
                  href="#"
                  onClick={() => handleTabChange('tab2')}
                >
                  Sound And Voice
                </a>
              </li>
                {/* 在这里添加更多选项卡 */}
                <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`}
                  href="#"
                  onClick={() => handleTabChange('tab3')}
                >
                  Languages
                </a>
              </li>
            </ul>
          </div>
          <div className="setting-main col-md-9">
            <div className="tab-content">
              <div className={`tab-pane ${activeTab === 'tab1' ? 'active' : ''}`}>
                {/* Tab 1 的设置内容 */}
                <h2>About Chatgpt</h2>
                {/* 添加 Tab 1 的设置内容 */}
              </div>
              <div className={`tab-pane ${activeTab === 'tab2' ? 'active' : ''}`}>
                {/* Tab 2 的设置内容 */}
                <h2>Sound and Voice</h2>
                {/* 添加 Tab 2 的设置内容 */}
              </div>
              <div className={`tab-pane ${activeTab === 'tab3' ? 'active' : ''}`}>
                {/* Tab 2 的设置内容 */}
                <h2>Languages</h2>
                {/* 添加 Tab 2 的设置内容 */}
              </div>
              {/* 在这里添加更多选项卡的设置内容 */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Setting